export default {
    errorBanner: {
        dismiss: 'Opusti',
    },
}
